import {
  ClientMentionContactsAdminGrid,
  type ClientMentionContactsAdminApi
} from '@jarvis/platform-ui';
import { useMemo } from 'react';
import {
  createClientMentionContact,
  deleteClientMentionContact,
  listClientMentionContacts,
  updateClientMentionContact
} from '../../../api/clientMentionContacts';

export function ClientMentionsAdminPage() {
  const api = useMemo<ClientMentionContactsAdminApi>(
    () => ({
      list: listClientMentionContacts,
      create: createClientMentionContact,
      update: updateClientMentionContact,
      delete: deleteClientMentionContact
    }),
    []
  );

  return (
    <div className="ops-fill-page ops-fill-page--bare">
      <div className="ops-fill-page__grid-host">
        <ClientMentionContactsAdminGrid api={api} stateStorageKey="webopsui:client-mentions-grid" />
      </div>
    </div>
  );
}
